export default "__VITE_ASSET__CHBrRd12__"